module.exports = __webpack_public_path__ + "static/media/efs_minsk_roads.b996f746.jpg";